import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth',
  styles: [':host .mat-drawer-content {padding: 0;} .mat-drawer-container {z-index: 1000}'],
  templateUrl: './auth.component.html'
})
export class AuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
